<template lang="pug">
div
    v-row(v-if="!mobile")
      v-col(cols=2 v-if="!$user")
          v-btn(block outlined elevation=1 @click="login" ) Login
      v-col(cols=2 v-if="!$user")
          v-btn(block outlined elevation=1 @click="signup") Sign up
      v-col(v-if="!recommenderMode" cols=2)
          v-btn(block outlined elevation=1 @click="recommender" ) EV Finder
      v-col(v-if="recommenderMode" cols=3)
          v-btn(block outlined elevation=1 @click="planner" ) Trip Planner
      v-col(cols=2)
          v-btn(block outlined elevation=1 @click="openSolarForm") Get Solar
      v-col(cols=2 v-if="$user")
          v-btn(block outlined elevation=1 @click="upload") Upload
      v-col(cols=2 v-if="$user")
          v-btn(block outlined elevation=1 @click="logout") Logout

      v-col(v-if="recommenderMode")
        v-btn(icon, @click="showSettings")
          v-icon mdi-cogs
    v-menu(v-if="mobile")
      template(v-slot:activator="{ on, attrs }")
        v-btn(color="primary" block text v-bind="attrs" v-on="on" ) More Options
      v-list
        v-list-item(v-if="!$user")
          v-btn(text elevation=0 @click="login" small) Login
        v-list-item(v-if="!$user")
          v-btn(text small @click="signup") Sign up
        v-list-item(v-if="!recommenderMode")
          v-btn(text small @click="recommender") EV Finder
        v-list-item(v-if="recommenderMode")
          v-btn(text small @click="planner") Trip Planner
        v-list-item
          v-btn(text small @click="openSolarForm") Get Solar
        v-list-item(v-if="recommenderMode")
          v-btn(@click="showSettings" text small)
            v-icon mdi-cogs
            |  Settings
        v-list-item(v-if="!recommenderMode")
          v-btn(@click="toggleMap" text small) Toggle Map
        v-list-item(v-if="$user")
          v-btn(text small @click="upload") Upload
        v-listitem(v-if="$user")
          v-btn(text small @click="logout") Logout
    v-dialog(v-model="dialog", max-width="540")
      v-card
        v-card-title.headline Adjust your settings
        v-card-text
          p The values below were chosen by your EV Dealer but feel free to adjust them to suit your situation.

          v-row(align="baseline", dense)
            v-col(cols=12, lg=9, order-lg=12)
              span Cost of petrol per litre
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.petrolCost",
                type="number",
                dense,
                solo,
                prefix="$"
              )
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.petrolConsumption",
                type="number",
                dense,
                solo
              )
            v-col(cols=12, lg=9)
              span km / litre if you drove a petrol car instead
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.dieselCost",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Cost of diesel per litre
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.dieselConsumption",
                type="number",
                dense,
                solo
              )
            v-col(cols=12, lg=9)
              span km / litre if you drove a diesel car instead
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.RUCperThousand",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Road User Charges in $ per thousand km
          v-row(align="baseline", dense)
            v-col(cols=12, lg=9)
              span Cost per kWh of electricty at home
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.homekWh",
                type="number",
                dense,
                solo,
                prefix="$"
              )
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.publickWh",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Cost per kWh of electricity in public
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.publicPerMinute",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Cost per minute of electricity in public
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.annualMaintenanceICE",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Annual maintenance on your current car
          v-row(align="baseline", dense)
            v-col(cols=12, lg=3, order="last", order-lg="first")
              v-text-field(
                v-model.number="settings.annualMaintenanceEV",
                type="number",
                dense,
                solo,
                prefix="$"
              )
            v-col(cols=12, lg=9)
              span Annual maintenance on an electric car
          v-row(dense, v-if="disclaimer")
            v-col(cols=12)
              .text-h6 Important details and information
              span(v-html="disclaimer")

        v-card-actions
          v-spacer
          v-btn(text, @click="updateSettings", color="green") Close
</template>
<script>
import { headerBus } from "../main";
import UserManagement from "../mixins/UserManagement";
export default {
  props: ["recommenderMode"],
  mixins: [UserManagement],
  data() {
    return {
      settings: this.$dealer.user_settings,
      disclaimer: this.$dealer.default_settings.disclaimer,
      dialog: false,
    };
  },
  created() {
    headerBus.$on("showSettings", () => {
      this.dialog = true;
    });
  },
  methods: {
    showSettings() {
      this.dialog = true;
    },
    recommender() {
      this.$router.push("/recommender/0");
    },
    planner() {
      this.$router.push("/planner");
    },
    signup() {
      this.$router.push("/new");
    },
    login() {
      this.$router.push("/login");
    },
    updateSettings() {
      this.dialog = false;
    },
    toggleMap() {
      headerBus.$emit("toggleMap");
    },
  },
};
</script>
